export const isNotBlankString = (item) => {
    if (typeof item === "string") {
        item = item.trim();
        if (0 in new Object(item)) {
            return true;
        }
    }
    return false;
};
export const splitWithSymbol = function (str, splitSymbol = ",", bit = 3) {
    const results = [];
    if (typeof str !== "string") {
        str = `${str}`;
    }
    let times = 0;
    while (true) {
        let begin = (times + 1) * -1 * bit;
        let end = times === 0 ? str.length : times * -1 * bit;
        let res = str.slice(begin, end);
        if (res === "") {
            break;
        }
        results.unshift(res);
        times++;
    }
    return results.join(splitSymbol);
};
export const oneMoreWords = (num = "") => num.length === 1 ? `${num}.0` : num;
export const mustHaveWords = (srcWords, words, gap = " ") => {
    return srcWords.includes(words)
        ? `${srcWords.replace(words, "").trim()}${gap}${words}`
        : `${srcWords}${gap}${words}`;
};
